export default __webpack_public_path__ + "static/media/lsp-tuk-1.77c7defa.jpg";